import EmployeePerformanceMenu from "./EmployeePerformanceMenu";

import styles from "../styles/Employee.module.css";

function EmployeePerformance({
  getPage = () => {},
  handleMenuChange = () => {},
}) {
  return (
    <div className={styles.content}>
      <EmployeePerformanceMenu onChange={handleMenuChange} />
      {getPage()}
    </div>
  );
}

export default EmployeePerformance;
